module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/02_introduction"
    }
  }, [_c('b', [_c('em', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_chapter01"
    }
  }, [_c('b', [_vm._v("Chapter: I Antiquity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/04_chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter II: Greek")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/04_chapter02#a01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Plato")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/04_chapter02#a02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dioscorides")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/04_chapter02#a03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Nonnus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter III: Romans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_chapter03#a04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ovid")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter IV: Orient")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter V: India")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter VI: Varieties and Occasions of Potions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter VII: Potency of Philtres")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter VIII: Ingredients of Potions. Recipes. Anecdotes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_chapter08#a05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ingredients")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter IX: Middle Ages and Later")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_chapter09#a06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Clauder")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter X: Modern Times")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bio",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('em', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0